// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /** The height of the time slider bar */
  --time-slider-height: 25px !important;
}

.time-slider-container {
  height: var(--time-slider-height);
  width: 100%;
  margin: 0 auto;
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  background: var(--color-dark-border);
  padding-top: 0.5em;
}

#time-slider-container-slider {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/plugins/time-slider/time-slider.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":[":root {\n  /** The height of the time slider bar */\n  --time-slider-height: 25px !important;\n}\n\n.time-slider-container {\n  height: var(--time-slider-height);\n  width: 100%;\n  margin: 0 auto;\n  padding: 0px 10px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  background: var(--color-dark-border);\n  padding-top: 0.5em;\n}\n\n#time-slider-container-slider {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
